import { Menu } from "@design-system/Menu/Menu.lib";
import { ReactNode } from "react";
import { useViewOnlyTooltipReason } from "@hooks/permissions/useViewOnlyTooltipReason";
import { MEMBER_RESTRICTION_TOOLTIP } from "./constants";

export const PermissionGuardedMenuItem = ({
    isAllowed,
    onClick,
    children,
    allowedTooltip,
}: {
    isAllowed: boolean;
    onClick: () => void;
    children: ReactNode;
    allowedTooltip?: string;
}) => {
    const tooltipReason = useViewOnlyTooltipReason(MEMBER_RESTRICTION_TOOLTIP);
    return (
        <Menu.Item
            onClick={onClick}
            disabled={!isAllowed}
            disabledReason={tooltipReason}
            tooltip={allowedTooltip}
        >
            {children}
        </Menu.Item>
    );
};
